export function googleDataToEntities(data) {
  try {
    return data.results.map(i => ({ address: i.formatted_address }));
  } catch (e) {
    return [];
  }
}
